import { render, staticRenderFns } from "./AccrualApproval.vue?vue&type=template&id=68563c61&scoped=true"
import script from "./AccrualApproval.vue?vue&type=script&lang=js"
export * from "./AccrualApproval.vue?vue&type=script&lang=js"
import style0 from "./AccrualApproval.vue?vue&type=style&index=0&id=68563c61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68563c61",
  null
  
)

export default component.exports